import { basename as m } from "path";
import d, { toRaw as p } from "vue";
import { t as u } from "./chunks/toast-d1cd63b1.mjs";
import { g as F, e as I, f as H, c as O, d as L, b as x, T as B, a as D, k as N, j as R, s as U, h as P, l as Z, i as j } from "./chunks/toast-d1cd63b1.mjs";
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const w = (e, t, i = () => {
}) => {
  const n = document.createElement("div");
  (document.querySelector(t == null ? void 0 : t.container) || document.body).appendChild(n);
  const l = new d({
    el: n,
    name: "VueDialogHelper",
    render: (o) => o(e, {
      props: t,
      on: {
        close: (...r) => {
          i(...r.map((h) => p(h))), l.$destroy();
        }
      }
    })
  });
}, f = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-move" viewBox="0 0 24 24"><path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></svg>', b = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-multiple" viewBox="0 0 24 24"><path d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z" /></svg>';
var A = Object.defineProperty, v = (e, t, i) => t in e ? A(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, s = (e, t, i) => (v(e, typeof t != "symbol" ? t + "" : t, i), i), T = /* @__PURE__ */ ((e) => (e[e.Choose = 1] = "Choose", e[e.Move = 2] = "Move", e[e.Copy = 3] = "Copy", e[e.CopyMove = 4] = "CopyMove", e[e.Custom = 5] = "Custom", e))(T || {});
class _ {
  constructor(t, i, n, a, l, o, r, h) {
    s(this, "title"), s(this, "multiSelect"), s(this, "mimeTypeFilter"), s(this, "directoriesAllowed"), s(this, "buttons"), s(this, "path"), s(this, "filter"), s(this, "container"), this.title = t, this.multiSelect = i, this.mimeTypeFilter = n, this.directoriesAllowed = a, this.path = o, this.filter = r, this.buttons = l, this.container = h;
  }
  /**
   * Pick files using the FilePicker
   *
   * @return Promise with array of picked files or rejected promise on close without picking
   */
  async pick() {
    const { FilePickerVue: t } = await import("./chunks/index-c0bccfab.mjs");
    return new Promise((i, n) => {
      w(t, {
        allowPickDirectory: this.directoriesAllowed,
        buttons: this.buttons,
        container: this.container,
        name: this.title,
        path: this.path,
        mimetypeFilter: this.mimeTypeFilter,
        multiselect: this.multiSelect,
        filterFn: this.filter
      }, (...a) => {
        var l;
        const [o] = a;
        !Array.isArray(o) || o.length === 0 ? n(new Error("FilePicker: No nodes selected")) : this.multiSelect ? i(o.map((r) => r.path)) : i(((l = o[0]) == null ? void 0 : l.path) || "/");
      });
    });
  }
}
class y {
  /**
   * Construct a new FilePicker
   *
   * @param title Title of the FilePicker
   */
  constructor(t) {
    s(this, "title"), s(this, "multiSelect", !1), s(this, "mimeTypeFilter", []), s(this, "directoriesAllowed", !1), s(this, "path"), s(this, "filter"), s(this, "buttons", []), s(this, "container"), this.title = t;
  }
  /**
   * Set the container where the FilePicker will be mounted
   * By default 'body' is used
   *
   * @param container The dialog container
   */
  setContainer(t) {
    return this.container = t, this;
  }
  /**
   * Enable or disable picking multiple files
   *
   * @param ms True to enable picking multiple files, false otherwise
   */
  setMultiSelect(t) {
    return this.multiSelect = t, this;
  }
  /**
   * Add allowed MIME type
   *
   * @param filter MIME type to allow
   */
  addMimeTypeFilter(t) {
    return this.mimeTypeFilter.push(t), this;
  }
  /**
   * Set allowed MIME types
   *
   * @param filter Array of allowed MIME types
   */
  setMimeTypeFilter(t) {
    return this.mimeTypeFilter = t, this;
  }
  /**
   * Add a button to the FilePicker
   * Note: This overrides any previous `setButtonFactory` call
   *
   * @param button The button
   */
  addButton(t) {
    return typeof this.buttons == "function" && (console.warn("FilePicker buttons were set to factory, now overwritten with button object."), this.buttons = []), this.buttons.push(t), this;
  }
  /**
   * Set the button factory which is used to generate buttons from current view, path and selected nodes
   * Note: This overrides any previous `addButton` call
   *
   * @param factory The button factory
   */
  setButtonFactory(t) {
    return this.buttons = t, this;
  }
  /**
   * Set FilePicker type based on legacy file picker types
   * @param type The legacy filepicker type to emulate
   * @deprecated Use `addButton` or `setButtonFactory` instead as with setType you do not know which button was pressed
   */
  setType(t) {
    return this.buttons = (i, n) => {
      var a, l, o;
      const r = [], h = ((l = (a = i == null ? void 0 : i[0]) == null ? void 0 : a.attributes) == null ? void 0 : l.displayName) || ((o = i == null ? void 0 : i[0]) == null ? void 0 : o.basename), c = h || m(n);
      return t === 1 && r.push({
        callback: () => {
        },
        label: h && !this.multiSelect ? u("Choose {file}", { file: h }) : u("Choose"),
        type: "primary"
      }), (t === 4 || t === 3) && r.push({
        callback: () => {
        },
        label: c ? u("Copy to {target}", { target: c }) : u("Copy"),
        type: "primary",
        icon: b
      }), (t === 2 || t === 4) && r.push({
        callback: () => {
        },
        label: c ? u("Move to {target}", { target: c }) : u("Move"),
        type: t === 2 ? "primary" : "secondary",
        icon: f
      }), r;
    }, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  allowDirectories(t = !0) {
    return this.directoriesAllowed = t, this;
  }
  /**
   * Set starting path of the FilePicker
   *
   * @param path Path to start from picking
   */
  startAt(t) {
    return this.path = t, this;
  }
  /**
   * Add filter function to filter file list of FilePicker
   *
   * @param filter Filter function to apply
   */
  setFilter(t) {
    return this.filter = t, this;
  }
  /**
   * Construct the configured FilePicker
   */
  build() {
    return new _(
      this.title,
      this.multiSelect,
      this.mimeTypeFilter,
      this.directoriesAllowed,
      this.buttons,
      this.path,
      this.filter
    );
  }
}
function V(e) {
  return new y(e);
}
export {
  _ as FilePicker,
  y as FilePickerBuilder,
  T as FilePickerType,
  F as TOAST_ARIA_LIVE_ASSERTIVE,
  I as TOAST_ARIA_LIVE_OFF,
  H as TOAST_ARIA_LIVE_POLITE,
  O as TOAST_DEFAULT_TIMEOUT,
  L as TOAST_PERMANENT_TIMEOUT,
  x as TOAST_UNDO_TIMEOUT,
  B as ToastAriaLive,
  D as ToastType,
  V as getFilePickerBuilder,
  N as showError,
  R as showInfo,
  U as showMessage,
  P as showSuccess,
  Z as showUndo,
  j as showWarning,
  w as spawnDialog
};
